export type ExcelMapperColSettingCodeFunction = (row:any, currentRow:any)=>string | number;

export enum ExcelMapperColSettingType {
	STRING = "string",
	VALUE = "value",
	CODE = "code"
}

export class ExcelMapperColSetting {
	Type:ExcelMapperColSettingType = ExcelMapperColSettingType.VALUE;
	Value:string = "";

	private scriptFunction:null | ExcelMapperColSettingCodeFunction = null;

	public constructor(data?:any) {
		if (!data) return;
		this.Type = data.Type || ExcelMapperColSettingType.STRING;
		this.Value = data.Value;
		if (this.Type == ExcelMapperColSettingType.CODE) {
			this.scriptFunction = ExcelMapperColSetting.createScriptFunction(this.Value);
		}
	}

	public getJSON(){
		return {
			Type: this.Type,
			Value: this.Value
		};
	}

	private static createScriptFunction(code:string):ExcelMapperColSettingCodeFunction {
		code = code.trim();
		let match;
		do {
			match = /{{\s*wf\.[\w\-\s\.]+\s*}}/g.exec(code);
			if (!match) continue;
			let txt = match[0].replaceAll("{", "").replaceAll("}", "").replace("wf.", "").trim();
			code = code.replaceAll(match[0], `currentRow["${txt}"]`);
		}while (match);

		do {
			match = /{{\s*[\w\-\s\.]+\s*}}/g.exec(code);
			if (!match) continue;
			let txt = match[0].replaceAll("{", "").replaceAll("}", "").trim();
			code = code.replaceAll(match[0], `row["${txt}"]`);
		} while (match);
		if (code.indexOf("\n") == -1 && !code.startsWith("return")) {
			code = `return ${code}`;
		}
		return new Function("row", "currentRow", code) as ExcelMapperColSettingCodeFunction;
	}

	// Returns an error message if script is not valid
	public static validateScript(content:string):string {
		try{
			ExcelMapperColSetting.createScriptFunction(content);
			return "";
		}catch(err){
			let error = err as any;
			if (error.toString){
				return error.toString();
			}
			if (typeof(error) == "object"){
				return JSON.stringify(error);
			}
			return error + "";
		}
	}

	public getValue(row:any, currentRow:any, isHeader:boolean = false):string | number {
		if (this.Type == "code" && this.scriptFunction) {
			return this.scriptFunction(row, currentRow);
		} else if (this.Type == "string") {
			return this.Value;
		} else if (this.Type == "value") {
			if (isHeader){
				return this.Value;
			}
			return row[this.Value];
		}
		throw new Error("Invalid excel mapper col setting type " + this.Type);
	}

	public toString():string {
		if (this.Value.length > 30) {
			return this.Value.substring(0, 30) + "...";
		}
		return this.Value;
	}
}